import React from 'react';

import { T } from '../stores/textStore';

const PurchaseSuccess = ({ orderNumber, total, isDonation, currencyCode}) => {
	if (!currencyCode) {
		currencyCode = 'USD';
	}
	let heading = 'Successfully processed your ' + (isDonation ? 'donation' : 'order') + '.'
	heading = T(heading);
	let text1 = 'Your ' + (isDonation ? 'donation' : 'order') + ' was processed successfully.';
	text1 = T(text1);	
    return (
        <div className="container">
          	<div className="row">
				<div className="col-md-12 text-center">
					<div className="alert alert-success" role="alert">
						{heading}
					</div>
					<p>
						{text1} {T('You will receive an email with further details.')}
					</p>
					<p>
						{T('Your order number is')} {orderNumber}. {T('Your order total is')} {currencyCode} {total}.
					</p>
					{isDonation &&
						<p>
							{T('Thank you for your support of The Kabbalah Centre.')}
						</p>
					}
				</div>
          	</div>
        </div>
    );
};

export default PurchaseSuccess;


// WEBPACK FOOTER //
// ./src/components/PurchaseSuccess.js